<template>
  <component :is="tag">
    <slot>{{ label }}</slot><span v-if="required" style="color: red"> *</span>
  </component>
</template>

<script setup lang="ts">
type Props = {
  label?: string;
  required?: boolean;
  tag?: string;
};

withDefaults(defineProps<Props>(), {
  tag: "label",
});
</script>
